import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import { ChartFormattingMixin } from './concerns/chart_formatting_mixin';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String, color: String, tooltipFormat: String, dataFormat: String };
  static targets = ['chartcanvas'];
  static chartData = null;
  static chartOptions = null;

  _buildChart() {
    Object.assign(this, ChartFormattingMixin);
    this.setChartData();
    this.setChartOptions();

    new Chart(this.chartcanvasTarget, {
      type: 'bar',
      data: this.chartData,
      options: this.chartOptions,
    });
  }

  chartOptionOverrides() {
    return {};
  }

  setChartOptions() {
    this.chartOptions = { ...this.#defaultChartOptions(), ...this.chartOptionOverrides() };
  }

  setChartData() {
    this.chartData = JSON.parse(this.inputsValue);
  }

  #defaultChartOptions() {
    return {
      maintainAspectRatio: true,
      responsive: true,
      plugins: {
        tooltip: {
          callbacks: {
            label: this.tooltipFormat(),
          },
        },
        legend: {
          display: false,
        },
      },
      elements: {
        bar: {
          backgroundColor: this.colorValue,
          borderRadius: 5,
        },
      },
      scales: {
        y: {
          grace: this.setGrace(this.chartData.datasets),
          beginAtZero: false,
          display: false,
          ticks: {
            callback: this.ticksFormat(),
            maxTicksLimit: this.hasMaxYTicksValue ? this.maxYTicksValue : undefined,
          },
          border: {
            display: false,
          },
        },
        x: {
          display: true,
          border: {
            display: false,
          },
          grid: {
            display: false,
          },
        },
      },
    };
  }
}
